module.exports = __webpack_public_path__ + "img/icon-top.d282a7e2.svg";